import { useMemo } from 'react'
import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
} from 'mobx-state-tree'
import { UserStore, IUserStore } from './UserStore'
import { AccountGroupTypeEnum } from '~/graphqls/types'
import { AiStore } from './AiStore'

const Modal = types
  .model({
    login: types.boolean,
    resetPwd: types.boolean,
  })
  .actions(self => {
    const setLoginVisible = (status: boolean) => {
      self.login = status
    }

    const setResetPwdVisible = (status: boolean) => {
      self.resetPwd = status
    }

    return {
      setLoginVisible,
      setResetPwdVisible,
    }
  })

const Equity = types.model({
  name: types.maybeNull(types.string),
  cardType: types.maybeNull(
    types.enumeration(Object.keys(AccountGroupTypeEnum))
  ),
})

const Layout = types.model({
  'homepage-layout': types.maybeNull(types.string),
  'plaza-layout': types.maybeNull(types.string),
})

const Store = types
  .model({
    token: types.maybeNull(types.string),
    userinfo: types.maybeNull(UserStore),
    /** 邀请人的邀请码（是邀请你的） */
    inviterCode: types.maybeNull(types.string),
    /** 技嘉云课程：章节ID */
    chapterId: types.maybeNull(types.string),
    ai: types.maybeNull(AiStore),
    aiEquity: types.maybeNull(types.array(Equity)),
    modal: types.maybeNull(Modal),
    showAmount: types.maybeNull(types.boolean),
    layout: types.maybeNull(Layout),
    /** 未读消息总数 */
    msgCount: types.maybeNull(types.number),
  })
  .actions(self => {
    const setToken = (token: string | null) => {
      self.token = token
    }
    const setUserinfo = (userinfo: IUserStore | null) => {
      self.userinfo = userinfo
    }

    const setShowAmount = (status: boolean) => {
      self.showAmount = status
    }
    const setInviterCode = (code: string | null) => {
      self.inviterCode = code
    }
    const setMsgCount = (val: number) => {
      self.msgCount = val
    }

    return {
      setToken,
      setUserinfo,
      setShowAmount,
      setInviterCode,
      setMsgCount,
    }
  })

export type IModal = Instance<typeof Modal>
export type IStore = Instance<typeof Store>
export type IStoreSnapshotIn = SnapshotIn<typeof Store>
export type IStoreSnapshotOut = SnapshotOut<typeof Store>

let store: IStore

export function initializeStore(snapshot: any = null) {
  const _store = store ?? Store.create()

  // If your page has Next.js data fetching methods that use a Mobx store, it will
  // get hydrated here, check `pages/ssg.tsx` and `pages/ssr.tsx` for more details
  if (snapshot) {
    applySnapshot(_store, snapshot)
  }
  // For SSG and SSR always create a new store
  if (typeof window === 'undefined') return _store
  // Create the store once in the client
  if (!store) store = _store

  return store
}

export function useInitStore(initialState: any) {
  const store = useMemo(() => initializeStore(initialState), [initialState])
  return store
}
